declare global {
    interface Error {
        name: string;
        message: string;
        stack?: string;
    }
}

export interface ErrorMessage {
    message: string;
}

export class RestApiError extends Error {
    public code: number;
    public response: any;

    constructor(message: string, code: number = 0, response: any = null) {
        super(message);
        this.name = 'RestApiError';
        this.message = message;
        this.code = code;
        this.response = response;
    }

}
